<app-app-bar></app-app-bar>

<app-main-content>
  <div class="spot-detail dash-container">
    <button type="button" class="spot-detail__back" (click)="back()">
      <mat-icon>arrow_back</mat-icon> Back to Spot Analysis
    </button>

    @if (loading()) {
    <div class="spot-detail__state" aria-live="polite">Loading spot details…</div>
    } @else if (error() || !details()) {
    <div class="spot-detail__state" role="alert">
      This spot could not be loaded.
    </div>
    } @else if (details(); as data) {
    <header class="spot-detail__header">
      <div class="spot-detail__title-icon" aria-hidden="true">
        <mat-icon>{{ data.spotType === "INDOOR" ? "apartment" : "place" }}</mat-icon>
      </div>
      <div>
        <h1>{{ data.commonName }}</h1>
        @if (location(data)) {
        <p>{{ location(data) }}</p>
        }
      </div>
    </header>

    <div class="spot-detail__times" role="tablist" aria-label="Time period">
      @for (time of timeFilters; track time.id) {
      <button
        type="button"
        class="spot-detail__time"
        [class.spot-detail__time--active]="activeTime() === time.id"
        [attr.aria-selected]="activeTime() === time.id"
        role="tab"
        (click)="setTime(time.id)"
      >
        {{ time.label }}
      </button>
      }
    </div>

    @for (internet of data.analysis.internet; track internet.useCase) {
    <section class="spot-detail__section" [attr.aria-labelledby]="'internet-' + internet.useCase">
      <div class="spot-detail__section-head">
        <div>
          <span class="spot-detail__eyebrow">{{ activityLabel(internet.useCase) }}</span>
          <h2 [id]="'internet-' + internet.useCase">{{ internet.qoeBadge || "Low data" }}</h2>
        </div>
        <span class="spot-detail__score">{{ internet.sampleCount > 0 ? internet.rating : "—" }}<small>/5</small></span>
      </div>
      <div class="spot-detail__meta">
        <span>{{ confidence(internet.confidence) }}</span>
        <span>{{ internet.sampleCount }} recent tests</span>
        @if (internet.lastMonitoredAt) {<span>Last monitored {{ internet.lastMonitoredAt | date:'short' }}</span>}
      </div>
    </section>
    } @empty {
    <section class="spot-detail__section spot-detail__state">
      Internet stats will appear after tests are recorded for this spot.
    </section>
    }

    <section class="spot-detail__section" aria-labelledby="availability-heading">
      <span class="spot-detail__eyebrow">Occupancy</span>
      <h2 id="availability-heading">{{ data.analysis.occupancy.sampleCount > 0 ? availability(data.analysis.occupancy.occupancyStatus) : "No data" }}</h2>
      <div class="spot-detail__availability">
        <div><span>Utilization</span><strong>{{ utilization(data.analysis.occupancy.sampleCount > 0 ? data.analysis.occupancy.utilization : null) }}</strong></div>
        <div><span>Observed clients</span><strong>{{ data.analysis.occupancy.clientCount ?? '—' }}</strong></div>
        <div><span>Samples</span><strong>{{ data.analysis.occupancy.sampleCount }}</strong></div>
        <div><span>Confidence</span><strong>{{ confidence(data.analysis.occupancy.confidence) }}</strong></div>
      </div>
    </section>
    }
  </div>
</app-main-content>
